import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Typography
} from '@material-ui/core'
import toSingularCategory from 'src/utils/News/toSingularCategory'
import { stripHtml } from 'src/utils/Html/stripHtml'
import { useStyles } from './NewsItemCard.styles'

interface NewsItemCardProps {
  idNews: number
  image: string
  alt: string
  category: string | null
  title: string
  text: string
}

const NewsItemCard = ({
  idNews,
  image,
  alt,
  category,
  title,
  text
}: NewsItemCardProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardActionArea
        component={RouterLink}
        to={`/news/${category}/${idNews}`}
        className={classes.cardActionArea}
      >
        <CardMedia
          component="img"
          image={image}
          title={alt}
          className={classes.img}
        />
        <CardContent className={classes.cardContent}>
          <Typography variant="body2" className={classes.category}>
            {t(`news.category.${toSingularCategory(category)}`)}
          </Typography>
          <CardHeader variant="body2" title={title} className={classes.title} />
          <Typography variant="body2" className={classes.text}>
            {stripHtml(text)}
          </Typography>
          <CardActions className={classes.actions}>
            <Button className={classes.actionsButton}>
              <Typography variant="body2">{t('button.read-more')}</Typography>
            </Button>
          </CardActions>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default NewsItemCard
